// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file automations/common.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.MinMaxAutomationLineItem
 */
export class MinMaxAutomationLineItem extends Message<MinMaxAutomationLineItem> {
  /**
   * Unique identifier for the min-max automation line item
   *
   * @generated from field: int32 id = 1;
   */
  id = 0;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId = "";

  /**
   * Trade name of the item
   *
   * @generated from field: string trade_name = 3;
   */
  tradeName = "";

  /**
   * Unit type of the item (e.g., tablet, bottle)
   *
   * @generated from field: string unit_type = 4;
   */
  unitType = "";

  /**
   * Unit of the item
   *
   * @generated from field: int32 unit = 5;
   */
  unit = 0;

  /**
   * Minimum quantity for the item
   *
   * @generated from field: float min_quantity = 6;
   */
  minQuantity = 0;

  /**
   * Maximum quantity for the item
   *
   * @generated from field: float max_quantity = 7;
   */
  maxQuantity = 0;

  /**
   * Current quantity of the item
   *
   * @generated from field: float current_quantity = 8;
   */
  currentQuantity = 0;

  /**
   * Safety stock level for the item
   *
   * @generated from field: float safety_stock = 9;
   */
  safetyStock = 0;

  /**
   * Timestamp of the last update
   *
   * @generated from field: google.protobuf.Timestamp last_updated = 10;
   */
  lastUpdated?: Timestamp;

  /**
   * Whether the automation is enabled for this item
   *
   * @generated from field: bool is_automated = 11;
   */
  isAutomated = false;

  constructor(data?: PartialMessage<MinMaxAutomationLineItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.MinMaxAutomationLineItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "trade_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "unit_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "unit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "min_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "max_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "current_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "safety_stock", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "last_updated", kind: "message", T: Timestamp },
    { no: 11, name: "is_automated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MinMaxAutomationLineItem {
    return new MinMaxAutomationLineItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MinMaxAutomationLineItem {
    return new MinMaxAutomationLineItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MinMaxAutomationLineItem {
    return new MinMaxAutomationLineItem().fromJsonString(jsonString, options);
  }

  static equals(a: MinMaxAutomationLineItem | PlainMessage<MinMaxAutomationLineItem> | undefined, b: MinMaxAutomationLineItem | PlainMessage<MinMaxAutomationLineItem> | undefined): boolean {
    return proto3.util.equals(MinMaxAutomationLineItem, a, b);
  }
}

